import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import { Vuelidate } from 'vuelidate/src';
import { sync } from 'vuex-router-sync';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VueABTasty from 'vue-abtasty';
import VueMeta from 'vue-meta';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Moment from 'moment';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store';
import App from '@/App.vue';
import { addHreflang } from '@/helpers/HreflangHelpers';

Moment.locale(process.env.VUE_APP_MOMENT_LOCALE || 'de');
Vue.prototype.$moment = Moment;
Vue.component('font-awesome-icon', FontAwesomeIcon);

sync(store, router);
Vue.use(Vuelidate);
Vue.use(VueScrollTo);
Vue.use(VueMeta);
Vue.use(VueABTasty, {
    identifier: process.env.VUE_APP_AB_TASTY_KEY,
    async: true,
});
Vue.config.productionTip = false;

if (process.env.VUE_APP_SENTRY_DSN) {
    Sentry.init({
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.VUE_APP_ENV,
        debug: process.env.VUE_APP_DEBUG,
        integrations: [
            new Integrations.Vue({
                Vue,
                attachProps: true,
                logErrors: true,
            }),
        ],
    });
}

let savedQueryParams = JSON.parse(localStorage.getItem('query-params'));
let globalQueryParams = { ...savedQueryParams };
document.URL.split('?')[1]?.split('&').forEach(item => {
    globalQueryParams[item.split('=')[0]] = item.split('=')[1];
});
localStorage.setItem('query-params', JSON.stringify(globalQueryParams));

if (document.URL.split('?')[1]) {
    localStorage.setItem('query-string', document.URL.split('?')[1]);
}
globalQueryParams.queryString = localStorage.getItem('query-string');

Vue.prototype.$globalQueryParams = globalQueryParams;

addHreflang();

const data = {
    'country': {
    },
};

import('@/resources/countries.json').then(module => module.default).then(response => {
    data.country = response.find(country => country.iso === process.env.VUE_APP_COUNTRY_ISO);
});

new Vue({
    router,
    store,
    i18n,
    data: data,
    render: h => h(App),
}).$mount('#app');
